/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Checkbox, Input, Typography } from '@atoms';
import { NO_MARGIN_BOTTOM } from '@constants';

import { DAY_FIELDS, regions } from './constants';
import Form from '../Form';

import s from './styles.module.less';

const DayForm = ({ onChange, countriesList, initialValues }) => {
  const [countries, setCountries] = React.useState(initialValues?.countries || []);

  React.useEffect(() => {
    if (countries !== initialValues?.countries) setCountries(initialValues.countries);
  }, [countries, initialValues]);

  const regionsCodes = React.useMemo(
    () => ({
      Asia: regions['Asia'].filter((id) => countriesList?.data?.find((country) => country.id === id)),
      Africa: regions['Africa'].filter((id) => countriesList?.data?.find((country) => country.id === id)),
      Europe: regions['Europe'].filter((id) => countriesList?.data?.find((country) => country.id === id)),
      Oceania: regions['Oceania'].filter((id) => countriesList?.data?.find((country) => country.id === id)),
      Americas: regions['Americas'].filter((id) => countriesList?.data?.find((country) => country.id === id)),
    }),
    [countriesList],
  );

  const isCountriesChecked = React.useMemo(
    () => ({
      Asia: isIncludeAllValues(countries, regionsCodes['Asia']),
      Africa: isIncludeAllValues(countries, regionsCodes['Africa']),
      Europe: isIncludeAllValues(countries, regionsCodes['Europe']),
      Oceania: isIncludeAllValues(countries, regionsCodes['Oceania']),
      Americas: isIncludeAllValues(countries, regionsCodes['Americas']),
    }),
    [regionsCodes, countries],
  );

  const checkAllCountries = React.useCallback(
    (e) => {
      const { name, checked } = e?.target;
      let newState = [];
      if (checked) {
        newState =
          name === 'all'
            ? [
                ...regionsCodes['Asia'],
                ...regionsCodes['Europe'],
                ...regionsCodes['Africa'],
                ...regionsCodes['Oceania'],
                ...regionsCodes['Americas'],
              ]
            : [...countries.filter((el) => !regionsCodes[name].includes(el)), ...regionsCodes[name]];
      } else {
        newState = name === 'all' ? [] : [...countries.filter((el) => !regionsCodes[name].includes(el))];
      }
      setCountries(newState);
      onChange(DAY_FIELDS.COUNTRIES.name, newState);
    },
    [countries, regionsCodes, onChange],
  );

  const handleChange = React.useCallback(
    (e) => {
      const { checked, value } = e?.target;

      const newCountries = checked ? [...countries, value] : countries.filter((el) => el !== value);
      setCountries(newCountries);
      onChange(DAY_FIELDS.COUNTRIES.name, newCountries);
    },
    [countries, onChange],
  );

  const RenderCountry = React.useCallback(
    ({ name }) => {
      return (
        <>
          <div>
            <div className={s.countryRegion}>
              <Typography.Title level={4} className={s.formItem}>
                {name}
              </Typography.Title>
              <Form.Item valuePropName="checked" style={NO_MARGIN_BOTTOM}>
                <Checkbox checked={isCountriesChecked[name]} name={name} onChange={checkAllCountries}>
                  All
                </Checkbox>
              </Form.Item>
            </div>
            <div>
              {regions[name]?.map((id) => {
                let itm = countriesList?.data?.find((country) => country.id === id);
                if (!itm) return <></>;

                return (
                  <div className={s.countryCheck} key={id}>
                    <Form.Item valuePropName="checked" style={NO_MARGIN_BOTTOM}>
                      <Checkbox checked={countries.includes(id)} value={id} onChange={handleChange}>
                        {itm?.name}
                      </Checkbox>
                    </Form.Item>
                  </div>
                );
              })}
            </div>
          </div>
          <hr className={s.divider} />
        </>
      );
    },
    [countriesList, checkAllCountries, countries, handleChange, isCountriesChecked],
  );

  return (
    <>
      <Form.Item label={DAY_FIELDS.SESSION_FIRST_URL.label} rules={DAY_FIELDS.SESSION_FIRST_URL.rules}>
        <Input
          onChange={({ target }) => onChange(target.name, target.value)}
          value={initialValues[DAY_FIELDS.SESSION_FIRST_URL.name]}
          placeholder={DAY_FIELDS.SESSION_FIRST_URL.placeholder}
          name={DAY_FIELDS.SESSION_FIRST_URL.name}
          id={DAY_FIELDS.SESSION_FIRST_URL.name}
        />
      </Form.Item>
      <Form.Item {...{ label: DAY_FIELDS.SESSION_SECOND_URL.label, rules: DAY_FIELDS.SESSION_SECOND_URL.rules }}>
        <Input
          onChange={({ target }) => onChange(target.name, target.value)}
          value={initialValues[DAY_FIELDS.SESSION_SECOND_URL.name]}
          placeholder={DAY_FIELDS.SESSION_SECOND_URL.placeholder}
          name={DAY_FIELDS.SESSION_SECOND_URL.name}
          id={DAY_FIELDS.SESSION_SECOND_URL.name}
        />
      </Form.Item>

      <Typography.Paragraph style={{ display: 'flex' }}>
        <Typography.Title level={4} style={{ marginRight: 5 }}>
          Countries
        </Typography.Title>
        {` (check countries where streaming is allowed)`}
      </Typography.Paragraph>
      <hr className={s.divider} />
      <Checkbox
        checked={isCountriesChecked.Asia && isCountriesChecked.Europe && isCountriesChecked.Americas}
        onChange={checkAllCountries}
        name="all"
      >
        All
      </Checkbox>
      <hr className={s.divider} />

      {['Asia', 'Europe', 'Americas', 'Oceania', 'Africa'].map((name) => (
        <RenderCountry name={name} key={name} />
      ))}
    </>
  );

  function isIncludeAllValues(arr, targetValues) {
    return targetValues.every((v) => arr.includes(v));
  }
};

DayForm.useForm = () => Form.useForm(DAY_FIELDS);

export default DayForm;
